import PropTypes from 'prop-types'
import { JsonViewer } from '../../../../../../../common/JsonViewer.jsx'
import { HeaderTitle } from '../../../../../../../common/HeaderTitle.jsx'
import { Col, Row } from 'react-bootstrap'
import InputNumericWiz from '../../../../../../../common/inputs/wizard/InputNumericWiz.jsx'
import { ZadaniaRepeater } from './ZadaniaRepeater.jsx'
import InputWiz from '../../../../../../../common/inputs/wizard/InputWiz.jsx'

export const ETAPY_CONFIG = {
    inicjacja: {
        title: 'Etap inicjacji',
        subtitle: 'Wprowadź informacje o etapie inicjacji projektu',
        prefix: 'inicjacja',
        section: 'A',
    },
    przygotowania: {
        title: 'Etap przygotowania',
        subtitle: 'Wprowadź informacje o etapie przygotowania projektu',
        prefix: 'przygotowania',
        section: 'B',
    },
    realizacja: {
        title: 'Etap realizacji',
        subtitle: 'Wprowadź informacje o etapie realizacji projektu',
        prefix: 'realizacja',
        section: 'C',
    },
    zamykania: {
        title: 'Etap zamykania',
        subtitle: 'Wprowadź informacje o etapie zamykania projektu',
        prefix: 'zamykania',
        section: 'D',
    },
}

export const EtapForm = ({ wiz, etapKey, showJsonViewer = true }) => {
    const config = ETAPY_CONFIG[etapKey]

    if (!config) {
        console.error(`EtapForm: Nieznany etapKey: ${etapKey}`)
        return null
    }

    const { title, subtitle, prefix, section } = config

    return (
        <>
            <JsonViewer src={wiz?.form || {}} show={showJsonViewer} />

            <HeaderTitle noHr size={'fs-3'} title={title} />

            <HeaderTitle noHr size={'fs-4'} title={subtitle} />

            <div className={'d-flex flex-column gap-3'}>
                <Row>
                    <Col xs={12} sm={4}>
                        <InputWiz
                            wiz={wiz}
                            keyName={`${prefix}_data_rozpoczecia`}
                            hideTime
                            readOnly={true}
                            disabled={true}
                        />
                    </Col>

                    <Col xs={12} sm={4}>
                        <InputWiz
                            wiz={wiz}
                            keyName={`${prefix}_data_zakonczenia`}
                            hideTime
                            readOnly={true}
                            disabled={true}
                        />
                    </Col>

                    <Col xs={12} sm={4}>
                        <InputNumericWiz
                            wiz={wiz}
                            keyName={`${prefix}_budzet_planowany`}
                            decimal={2}
                            readOnly={true}
                            disabled={true}
                        />
                    </Col>
                </Row>

                <div className={'d-flex flex-column gap-3'}>
                    <ZadaniaRepeater
                        wiz={wiz}
                        parentListName={`${prefix}_zadania_list`}
                        sumField={`${prefix}_budzet_planowany`}
                        section={section}
                        startDateField={`${prefix}_data_rozpoczecia`}
                        endDateField={`${prefix}_data_zakonczenia`}
                    />
                </div>
            </div>
        </>
    )
}

EtapForm.propTypes = {
    wiz: PropTypes.any.isRequired,
    etapKey: PropTypes.oneOf(['inicjacja', 'przygotowania', 'realizacja', 'zamykania']).isRequired,
    showJsonViewer: PropTypes.bool,
}

export default EtapForm
